<template>
    <div class="scheduleList-wrap">

      <Modal
        class="scheduleList "
        width="1200"
        footer-hide
        :closable="false"
        :mask-closable="false"
        v-model="parameter">
        <div slot="header">
          <p class="header-title">自主排班</p>
        </div>

        <div class="contant-schedule">
          <Table
            disabled-hover
            :row-class-name="rowClassName"
            :columns="columns"
            style=""
            height="600"
            :data="scheduleData"></Table>
            <p type="text"  @click="handlerMoreData" class="more-btn">加载更多>></p>
          <Drawer
            class-name="ivu-drawer-wrap-schedule"
            placement="right"
            :transfer="false"
            :inner="true"
            :mask="false"
            width="40"
            :closable="false"
            v-model="scheduleSrawer">
              <p>{{editDrawer.titleDrawer}}</p>
              <Form :model="editDrawer" >
                <FormItem label="排班日期"  >
                  <p>{{editDrawer.date}}</p>
                   <!-- <DatePicker 
                    format="yyyy-MM-dd" 
                    size="small" 
                    placeholder="选择日期" 
                    disabled 
                    v-model="editDrawer.date">
                  </DatePicker> -->
                </FormItem>

                <FormItem label="开始时间">
                   <TimePicker 
                    format="HH:mm" 
                    size="small" 
                    :clearable="false"
                    placeholder="选择时间"  
                    style="width: 170px"
                    v-model="editDrawer.myDate"></TimePicker>
                </FormItem>

                <!-- 新增可以选择科室 -->
                <FormItem label="出诊科室">
                   <Select 
                      v-model="editDrawer.departmentID" 
                      filterable
                      remote
                      :remote-method="getHospitalDepartment"
                      :loading="loadingDepartment"
                      style="width: 170px"
                      @on-query-change="handlerQueryChange"
                      v-if="editDrawer.isAdd"><Option 
                        v-for="item in hospitalDepartment" 
                        :value="item.id" 
                        :key="item.id"
                       >{{ item.name }}</Option>
                  </Select>
                  <p v-if="!editDrawer.isAdd">{{editDrawer.department}}</p>
                </FormItem>


                <FormItem label="持续时长">
                   <InputNumber size="small" :max="24" :min="0.5" :step="0.5" v-model="editDrawer.schedulingContinue"></InputNumber> 小时
                </FormItem>

                <FormItem label="号源数量">
                   <InputNumber size="small" :max="100" :min="1" :step="1" v-model="editDrawer.schedulingNum"></InputNumber>个
                </FormItem>
              </Form>

              <div class="record-footer">
                  <Button type="primary" @click="handlerAddSchedule">确定</Button>
                  <Button @click="handlerCancleDrawer">取消</Button>
              </div>
          </Drawer>

          <div class="record-footer">
              <Button type="primary" @click="handlerAddOpenDrawer">新增</Button>
              <Button @click="handlerCancle">关闭</Button>
          </div>

        </div>

      </Modal>

      <Modal v-model="cancleScheduleModel" style="width: 300px;" class="cancleScheduleModel">

        <div style="text-align:center">是否确认停止排班</div>
        <div slot="footer">
            <Button type="error" size="large" long  @click="handlercloseScheduling">确定</Button>
        </div>
    </Modal>

    </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters } from 'vuex'
export default {
  name: 'recordModel',
  props: {
    parameter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 科室列表
      hospitalDepartment: [],
      historyhospitalDepartment: [],
      loadingDepartment: false,
      lockDepartmentSearch: false,
      cancleScheduleModel: false,
      pageSize: 10,
      pageNum: 1,
      renderTotal: 0,
      editDrawer: {
        titleDrawer: '新增排班',
        schedulingContinue: 0.5,
        schedulingNum: 1,
        index: 0,
        departmentID: null,
        isAdd: true
      },
      scheduleSrawer: false,
      scheduleData: [],
      columns: [
        {
          title: '状态',
          align: 'center',
          key: 'schedulingStatusText',
          render: (h, params) => {
            let backgroundp = '#7d7d7d'
            if (params.row.schedulingStatus === 0) {
              backgroundp = '#26D023'
            } else if (params.row.schedulingStatus === 1) {
              backgroundp = '#32C5FF'
            }
            return h('div', [
              h('span', {
                props: {
                  type: 'person'
                },
                style: {
                  'background': backgroundp,
                  'color': '#fff',
                  'font-size': '0.33rem',
                  'padding': '0.1rem 0.2rem',
                  'border-radius': '1rem'
                }
              }, params.row.schedulingStatusText)
            ])
          }
        },
        {
          title: '排班时间',
          align: 'center',
          key: 'schedulingStartTime',
          render: (h, params) => {
            return h('div', params.row.schedulingStartTime + '-' + params.row.schedulingEndTime)
          }
        },
        {
          title: '号源数量(个)',
          align: 'center',
          key: 'schedulingNum'
        },
        {
          title: '时长(小时)',
          align: 'center',
          key: 'schedulingContinue'
        }, {
          title: '排班日期',
          align: 'center',
          key: 'date'
        }, {
          title: '操作',
          align: 'center',
          key: 'action',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small',
                  color: '#0091FF',
                  disabled: (params.row.schedulingStatus === 2)
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editDrawer = {
                      ...params.row,
                      myDate: params.row.schedulingStartTime,
                      titleDrawer: '编辑排班',
                      isAdd: false
                    }
                    this.handlerOpenDrawer()
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small',
                  color: '#0091FF',
                  disabled: (params.row.schedulingStatus === 2)
                },
                on: {
                  click: () => {
                    this.editDrawer.schedulingId = params.row.schedulingId
                    this.cancleScheduleModel= true
                  }
                }
              }, '停诊')
            ])
          }
        }
      ]
    }
  },

  created: function () {
    this.initCurTime()
  },

  methods: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest'
    }),
    handlerQueryChange (){
      this.lockDepartmentSearch = true
    },
    // 获取科室列表
    getHospitalDepartment(query){
     
      // 去除首尾空格后请求接口
      query = query.replace(/(^\s*)|(\s*$)/g, "")
      if(!query || !this.lockDepartmentSearch){
        return false
      }
      console.log(query)
      this.loadingDepartment = true

      api.getHospitalDepartmentShift({
        data: {
          params: {
            keyword: query
          }
        }
      })
      .then(res => {
        this.loadingDepartment = false
        this.hospitalDepartment = res.data.departmentArray
      })
    },

    changeTime(dateDay,dateTime){
     this.editDrawer.schedulingStartTimeString = new Date(dateDay + ' ' + dateTime).getTime()
     console.log(this.editDrawer.schedulingStartTimeString)
    },

    // 获取当前时间
    initCurTime () {
      let myDate = new Date()
      myDate.getHours() // 获取当前小时数(0-23)
      myDate.getMinutes() // 获取当前分钟数(0-59)
      this.editDrawer.myDate = myDate.getHours() + ':' + myDate.getMinutes()
      this.editDrawer.date = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate()
      
      this.editDrawer.schedulingStartTimeString =  myDate.getTime()
    },
    rowClassName (row, index) {
      if (row.schedulingStatus === 2) {
        return 'table-info-disable'
      }
      return ''
    },
    // 获取排班列表
    getscheduleList (more) {
       if( more != 1){
         this.pageNum=1
       }
      api.getSelfSchedulingList({
        data: {
          params: {
            pageNum: this.pageNum
          }
        }
      })
        .then(res => {
          this.renderTotal = res.data.array.length
          this.pageSize = res.data.pageSize

          this.$set(this.hospitalDepartment,0,{
            id: res.data.preDepartmentId,
            name: res.data.preDepartmentName
          })
          this.historyhospitalDepartment = this.hospitalDepartment
          this.editDrawer.departmentID = res.data.preDepartmentId
          
          console.log(this.hospitalDepartment)
          // console.log(111)
          if( more == 1){
            if(res.data.array.length >=0 && more == 1){
               this.scheduleData = this.scheduleData.concat(res.data.array)
               console.log(JSON.stringify(this.scheduleData))
            }
          }else{
            this.scheduleData = res.data.array
          }
          
        })
    },
    // 新增排班
    handlerAddSchedule () {
      // 将开始时间转变为时间戳
      this.editDrawer.schedulingStartTimeString = new Date(this.editDrawer.date + ' ' + this.editDrawer.myDate).getTime()
      
      api.addNewScheduling({
        data: {
          params: {
            schedulingId: this.editDrawer.schedulingId,
            schedulingStartTime: this.editDrawer.schedulingStartTimeString,
            schedulingNum: this.editDrawer.schedulingNum,
            continueTime: this.editDrawer.schedulingContinue,
            departmentID: this.editDrawer.departmentID
          }
        }
      })
        .then(res => {
          if(res.data.tip){
            this.$Message.warning(res.data.tip);
          }else{
            this.getscheduleList()
            this.handlerCancleDrawer()

          }
          
        })
    },
    // 加载更多
    handlerMoreData () {
      if (this.renderTotal >= this.pageSize) {
         ++this.pageNum
        this.getscheduleList(1)
      }
    },
    // 停诊
    handlercloseScheduling () {
      api.closeScheduling({
        data: {
          params: {
            schedulingId: this.editDrawer.schedulingId
          }
        }
      })
        .then(res => {
          this.pageNum = 1
          this.cancleScheduleModel = false

          this.getscheduleList()

        })
    },
    handlerAddOpenDrawer(){
      this.editDrawer.titleDrawer="新增排班"
      this.editDrawer.isAdd = true
      this.editDrawer.departmentID = this.historyhospitalDepartment[0].id
      this.hospitalDepartment = this.historyhospitalDepartment 
      this.editDrawer.schedulingId = ''
      this.initCurTime()
      this.handlerOpenDrawer()
    },
    // 打开抽屉
    handlerOpenDrawer () {
      this.scheduleSrawer = true
    },
    // 关闭抽屉
    handlerCancleDrawer () {
      this.scheduleSrawer = false
    },
    // 关闭弹窗
    handlerCancle () {
      this.$emit('handlermodalCancel', {
        parameter: false
      })
    }

  },
  watch: {
    parameter: function (val) {
      if (val) {
        this.getscheduleList()
      }
    }
  }
}

</script>

<style>
.header-title{
  background: #72beff;
  color: #fff;
}
.scheduleList{
  min-height: 800px;
}
.ivu-modal{
  width: 80% !important;
}
.scheduleList .ivu-modal-header{
  background: #72beff;
  color: #fff;
}
.scheduleList .ivu-modal-body{
  padding: 0.5rem 0 0 !important;
}
.scheduleList .ivu-modal-header p{
  color: #fff !important;
}
.table-info-disable{
  opacity: 0.7;
}
.contant-schedule{
  position: relative;
}
.record-footer{
  text-align: center;
  padding: 0  0  0.5em 0;

}
.scheduleList .record-footer button{
  margin: 0 2%;
  width: 100px;
}

.ivu-drawer-body{
  padding: 0;
}
.record-footer .ivu-btn-primary{
  background: #72BEFF;
  border: none;
}
.ivu-drawer-content-no-mask{
  padding: 0 0.5rem;
}
.scheduleList .ivu-form-item-content{
  width: 200px !important;
}
.cancleScheduleModel .ivu-modal{
  width: 300px !important;
  top: 30%;
}
.more-btn{
    width: 100%;
    text-align: center;
    cursor: pointer;
    line-height: 60px;
}
.ivu-drawer-wrap-schedule .ivu-drawer-inner{
  width: 40%
}

</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/selfSchedule/index.vue